import { render } from "./EventItem.vue?vue&type=template&id=4a4988b0"
import script from "./EventItem.vue?vue&type=script&lang=js"
export * from "./EventItem.vue?vue&type=script&lang=js"

import "./EventItem.vue?vue&type=style&index=0&id=4a4988b0&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__